@if (interval() === 12) {
  <div layout>
    <div class="price-without-discount">
      {{ monthCost }}
    </div>
    <div class="price">
      {{ yearCost }} /
      {{ 'app.common.month' | translate }}
    </div>
  </div>
}
@if (interval() === 1) {
  <div layout>
    <div class="price">
      {{ monthCost }} /
      {{ 'app.common.month' | translate }}
    </div>
  </div>
}
